import { useCallback } from "react"
import { DatePicker, FormSelect } from "@nef/core"
import moment from "moment"

import { SelectOption } from "../../types/common"
import { CustomFilterTypes } from "../../types/_enums"
import { DISPLAY_DATE_FORMAT } from "../../constants/common"
import { getPayloadDateFormat } from "../../utils/common"

const CustomTableFilter = ({
  column,
  data,
  fieldName,
  customLabelList,
  customOptions,
  filterByEnum = false,
  filterType = CustomFilterTypes.SELECT
}: any) => {
  const { filterValue, setFilter } = column
  const handleChange = ({ value }: any) => {
    setFilter(value.label ? `= ${value.label}` : value.label)
  }
  const handleChangeForEnum = ({ value }: any) => {
    setFilter(value.value ? `${value.value}` : value.value)
  }
  const allowedOptions =
    customOptions ??
    [
      ...new Set(
        data
          .reduce((acc: SelectOption[], curr: any) => {
            if (curr?.[fieldName]) {
              const option: SelectOption = {
                label: customLabelList ? customLabelList[curr[fieldName] as keyof typeof customLabelList] : curr[fieldName],
                value: curr[fieldName]
              }
              acc.push(option)
            }
            return acc
          }, [])
          .map((item: SelectOption) => JSON.stringify(item))
      )
    ].map((item: any) => JSON.parse(item))

  const getDateValue = useCallback((value: string) => {
    if (!value) return undefined
    return moment(value).toDate()
  }, [])

  return filterType === CustomFilterTypes.SELECT ? (
    <FormSelect
      placeholder=" "
      options={allowedOptions}
      value={allowedOptions.find((item: SelectOption) => item.label === filterValue?.split("= ")?.[1])}
      onChange={filterByEnum ? handleChangeForEnum : handleChange}
      size="sm"
    />
  ) : filterType === CustomFilterTypes.DATE ? (
    <DatePicker
      format={DISPLAY_DATE_FORMAT}
      className="field-repo__input"
      size="sm"
      value={getDateValue(filterValue)}
      onChange={({ value: val }: any) => {
        setFilter(getPayloadDateFormat(val?.$d))
      }}
      placeholder={DISPLAY_DATE_FORMAT}
      autoComplete="off"
    />
  ) : null
}

export default CustomTableFilter
